export default __webpack_public_path__ + "static/media/MLBBPro-Project.9f51824d.PNG";